var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"MyMap"}},[_c('div',{staticStyle:{"border":"solid 3px rgb(0, 94, 173)"}},[_c('div',{ref:"map",staticStyle:{"height":"400px","width":"auto"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }